// 提取主页
<template>
	<div v-if="showFlag" class="ehp-container">
		<div class="content">
			<div class="new-year-area"></div>
			<div class="title_1">绝密数据库</div>
			<div class="center-c">
				<div class="extract-btn-wapper">
					<div class="ebw-btn" @click="extactJump"></div>
				</div>
				<div class="money-bg-wapper">
					<transition name="moneyFade">
						<div class="money-bg"></div>
					</transition>
				</div>
			</div>
		</div>
		<div class="bottom"></div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				showFlag: false,
			}
		},
		mounted() {
			let obj = this.$common.getRequest()
			let vdata = obj['vdata'] || ''
			if (vdata) {
				localStorage.setItem('vdata', vdata)
				this.showFlag = true
			} else {
				let index = window.location.href.indexOf('?')
				let path = window.location.href
				if (index != -1) {
					path = window.location.href.substring(0, index)
				}
				window.location.replace(`${this.$BASE_URL}/?rurl=${path}`)
			}
		},
		methods: {
			extactJump() {
				this.$router.replace('/immediate-extraction')
			},
		},
	}
</script>
<style lang="scss" scoped>
	@keyframes Tada {
		0% {
			transform: scale(1);
			transform: scale(1);
		}

		10%,
		20% {
			transform: scale(0.9) rotate(-3deg);
			transform: scale(0.9) rotate(-3deg);
		}

		30%,
		50%,
		70%,
		90% {
			transform: scale(1.1) rotate(3deg);
			transform: scale(1.1) rotate(3deg);
		}

		40%,
		60%,
		80% {
			transform: scale(1.1) rotate(-3deg);
			transform: scale(1.1) rotate(-3deg);
		}

		100% {
			transform: scale(1) rotate(0);
			transform: scale(1) rotate(0);
		}
	}
	@keyframes Show1 {
		0% {
			opacity: 0;
			transform: translateY(1.1rem);
		}
		25% {
			opacity: 1;
		}
		100% {
			opacity: 1;
			transform: translateY(0);
		}
	}
	@keyframes Breathing {
		0% {
			transform: scale(1.15);
		}
		25% {
			transform: scale(1.1);
		}
		50% {
			transform: scale(1.05);
		}
		100% {
			transform: scale(1);
		}
	}
	.ehp-container {
		z-index: 100;
		width: 10rem;
		// height: 19.692982rem;
		height: 100vh;
		background: url('/style/assets/image/p1/bg_1.png')
			no-repeat;
		background-size: 100% 100%;
		.content {
			padding-top: 1.8rem;
			.new-year-area {
				height: 2.08rem;
				width: 100%;
				// margin-bottom: 0.266667rem;
				background: url('/style/assets/image/p1/new-year.png')
					center center no-repeat;
				background-size: 6.533333rem 100%;
			}
			.title_1 {
				height: 1.786667rem;
				width: 100%;
				color: #f2e4ce;
				font-family: SourceHanSansCN-Bold;
				font-size: 1.2rem;
				text-align: center;
				line-height: 1.786667rem;
				margin-bottom: 1.466667rem;
			}
			.center-c {
				position: fixed;
				// top: calc(50vh - 4.306665rem);
				top: calc(50vh - 2.5rem);
				// top: 50vh;
				left: 0;
				width: 100vw;
				.extract-btn-wapper {
					width: 100%;
					height: 1.813333rem;
					display: flex;
					justify-content: center;
					.ebw-btn {
						width: 5.013333rem;
						height: 100%;
						background: url('/style/assets/image/home-page_btn.png')
							no-repeat;
						background-size: 100% 100%;
						text-align: center;
						line-height: 1.65rem;
						color: #fff;
						font-size: 0.8rem;
						font-family: SourceHanSansCN-Bold;
						-webkit-animation: Breathing 1s 2s both infinite;
						-moz-animation: Breathing 1s 2s both infinite;
						-ms-animation: Breathing 1s 2s both infinite;
						animation: Breathing 1s 2s both infinite;
					}
				}
				.money-bg-wapper {
					width: 100%;
					display: flex;
					justify-content: center;
					.money-bg {
						width: 6.8rem;
						height: 6.8rem;
						background: url('/style/assets/image/p1/money_bg.png')
							no-repeat;
						background-size: 100% 100%;
						-webkit-animation: Tada 1s 2s both infinite;
						-moz-animation: Tada 1s 2s both infinite;
						-ms-animation: Tada 1s 2s both infinite;
						animation: Tada 1s 2s both infinite;
					}
				}
			}
		}
		.bottom {
			position: fixed;
			bottom: 0;
			left: 0;
			width: 100%;
			height: 1.6rem;
			background: url('/style/assets/image/p1/bottom.png')
				center center no-repeat;
			// background-size: 100% 100%;
			background-size: 6.6rem 1.1rem;
			-webkit-animation: Show1 1s 1s both;
			-moz-animation: Show1 1s 1s both;
			-ms-animation: Show1 1s 1s both;
			animation: Show1 1s 1s both;
		}
	}
</style>
